import React from 'react';
import styled from 'styled-components';
import PersuaderDetailCard from 'Components/arctypes/components/PersuaderDetailCard';
import PersonalityGeneralDetails from 'Components/arctypes/components/PersonalityGeneralDetails';
// import PeopleCardLarge from 'Components/common/components/PeopleCardLarge';
// import ArrowRightIcon from 'Components/common/assets/svgIcons/ArrowRightIcon';
import { Row, Col } from 'antd';
// import { Link } from 'react-router-dom';
// import { persuader } from 'Utils/utilsStyle';
import PersonaQualities from './PersonaQualities';
import arcType from '../arcType.json';

const Wrapper = styled.div`
 .recomended-users{
    a{
      color:${arcType[0].color};
      svg path{
        fill:${arcType[0].color};
      }
    }
  }
`;

const PersuaderTab = function PersuaderTab() {
  return (
    <Wrapper className="personality-detail-card">
      <PersuaderDetailCard />
      {/* <Row className="recomended-users">
        <Col span={12}>
          <h3 className="sub-heading">
            {`${arcType[0].title}'s`}
            {' '}
            in my Network:
          </h3>
        </Col>
        <Col span={12}>
          <Link to="/">
            See all
            <ArrowRightIcon color={arcType[0].color} />
          </Link>
        </Col>
        <Col span={24} className="d-flex justify-content-between drivers-list">
          {[1, 2, 3, 4, 5].map(() => (
            <PeopleCardLarge noFollow />
          ))}
        </Col>
      </Row> */}
      <PersonalityGeneralDetails>
        <Row gutter={70} className="general-detail-persona">
          <Col span={24}>
            <h2 className="title-persona">
              General
              {' '}
              {`${arcType[0].title}'s`}
              {' '}
              Insights
            </h2>
          </Col>
          <Col span={12}>
            <h3 className="sub-heading">Strengths</h3>
            <ul>
              {arcType[0].strength?.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Motivators</h3>
            <p>
              {arcType[0].motivators}
            </p>
            <h3 className="sub-heading">On the Phone</h3>
            <ul>
              {arcType[0].on_the_phone?.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Email</h3>
            <p>{arcType[0].email?.description}</p>
            <ul>
              {arcType[0].email?.tips.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Communication Style</h3>
            <p>
              {arcType[0].communication_style}
            </p>
          </Col>
          <Col span={12}>
            <h3 className="sub-heading">Weaknesses</h3>
            <ul>
              {arcType[0].weaknesses?.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Stressors</h3>
            <p>
              {arcType[0].stressors}
            </p>
            <h3 className="sub-heading">Meeting</h3>
            <p>{arcType[0].meeting?.description}</p>
            <ul>
              {arcType[0].meeting?.tips.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Feedback</h3>
            <p>{arcType[0].feedback?.description}</p>
            <ul>
              {arcType[0].feedback?.tips.map((item, key) => <li tabIndex={key}>{item}</li>)}
            </ul>
            <h3 className="sub-heading">Conflict Resolution</h3>
            <p>
              {arcType[0].conflict_resolution}
            </p>
          </Col>
          <Col span={24}>
            <h3 className="sub-heading">Job Roles</h3>
            <div className="job-roles">
              {arcType[0].job_roles?.map((item, key) => (
                <PersonaQualities
                  backgroundColor={arcType[0].color}
                  name={item}
                  index={key}
                />
              ))}
            </div>
          </Col>
        </Row>
      </PersonalityGeneralDetails>
    </Wrapper>
  );
};

export default PersuaderTab;
